import { css } from '@emotion/react';
import { Col, Icon, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';

import ChartDescriptionsModal from '@/src/compliance/components/CompliAssist/ChartDescriptions/Modal';
import Form from '@/src/shared/components/Form';
import Heading from '@/src/shared/components/Heading';
import X from '@/src/shared/components/Icon/_icons/X';
import Sanitize from '@/src/shared/components/Sanitize';
import { bp, space } from '@/styles';
import { rowProps } from '@/utils/rowColHelpers';
import { multiSelectProps } from '@/utils/selectHelpers';
import { scrollToElement } from '@/utils/utils';

import style from '../style';

const selectMargin = css`
  @media ${bp.lg} {
    margin-left: 1.2rem;
  }
`;

const { m } = space;

const { Option } = Select;

const CompliAssistCharts = props => {
  const { charts, designData, form, profile, setManuallyTouched } = props;
  const [isVisible, setModalVisibility] = useState(false);

  const { block, blockComponents } = designData;

  const clear = () => {
    form.setFieldsValue({
      CompliAssistCharts: [],
    });
    setManuallyTouched(true);
  };

  const selectAll = () => {
    const allCharts = charts.map(c => c.ChartId);
    form.setFieldsValue({
      CompliAssistCharts: allCharts,
    });
    setManuallyTouched(true);
  };

  useEffect(() => {
    if (window.location.hash) {
      scrollToElement(window.location.hash.replace('#', ''), 80);
    }
  }, []);

  return (
    <div id="compliassist" css={style.rowWidth}>
      <ChartDescriptionsModal visible={isVisible} closeModal={() => setModalVisibility(false)} />
      <Heading type={2} theme="primaryGray" size="md" weight="bold">
        {block.BlockTitle}
      </Heading>
      {blockComponents.map(c => (
        <div key={c.BlockComponentId} css={style.description}>
          <Sanitize>{c.Paragraph}</Sanitize>
        </div>
      ))}
      <Row {...rowProps} css={m.t16}>
        <Col xs={24}>
          <Form.Item
            css={style.hasClear}
            label={
              <>
                <span>CompliAssist Charts</span>
                <div css={style.chartActions}>
                  <Heading type={3} weight="bolder" size="xs" onClick={selectAll}>
                    <span css={style.chartText}>
                      <Icon type="check" />
                      <span css={m.l8}>Select All</span>
                    </span>
                  </Heading>
                  <Heading type={3} size="xs" weight="bolder" css={selectMargin} onClick={clear}>
                    <span css={style.chartText}>
                      <X /> <span css={m.l8}>Clear Choices</span>
                    </span>
                  </Heading>
                </div>
              </>
            }
          >
            {form.getFieldDecorator('CompliAssistCharts', {
              initialValue: profile.CompliAssistCharts,
            })(
              <Select
                {...multiSelectProps(false)}
                maxTagCount={5}
                size="large"
                css={style.whiteField}
              >
                {charts.map(c => (
                  <Option key={`${c.ChartId}-chart`} value={c.ChartId}>
                    {c.ChartTitle}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

CompliAssistCharts.propTypes = {};

export default CompliAssistCharts;
